import * as yup from 'yup';

export const commonCampaignsValidationSchema = yup.object({
  totalBudgetSum: yup.number().integer().required().min(0),
  agreementTermsAndConditions: yup.boolean().required(),
});
